import { render } from "./MasterDataTableForm.vue?vue&type=template&id=14a07981&scoped=true&ts=true"
import script from "./MasterDataTableForm.vue?vue&type=script&lang=ts"
export * from "./MasterDataTableForm.vue?vue&type=script&lang=ts"

import "./MasterDataTableForm.vue?vue&type=style&index=0&id=14a07981&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14a07981"]])

export default __exports__